import { Checkbox, FormControlLabel } from '@mui/material'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'

const MyCheckBox = ({ value, setValue, label, ...rest }) => {

	const [valueTemp, setValueTemp] = useState(value) // Тут зробив, бо ззовні не оновлювався стейт

	useEffect(() => {
		// if (value) {
			setValueTemp(value)
		// }
	}, [value])

//   console.log('valueTemp', valueTemp)

  return (
    <FormControlLabel 
        className='myCheckBox'
        control={
            <Checkbox 
                checked={valueTemp}
                onChange={e => {
                    setValue(!valueTemp)
					setValueTemp(!valueTemp)
                }}
                {...rest}
            />
        } 
        label={label} 
    />
  )
}

export default MyCheckBox